import Item from "./item";
import totalSupply from "@assets/totalSupply.svg";
import circulating from "@assets/circulating.svg";
import fisPrice from "@assets/fisPrice.svg";
import marketCap from "@assets/marketCap.svg";
import "./index.scss";
import { useEffect, useState } from "react";
import { getHeaderData } from "@api/index";
import { formateNum, formatNumber } from "@/tool/utils";

export default function Index() {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>();
  useEffect(() => {
    setLoading(true);
    getHeaderData()
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {})
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <div className="fisInfo">
      <Item
        price={`${formatNumber(data?.totalSupply, { decimals: 2 })}`}
        spin={loading}
        unit="FIS"
        tips={
          "FIS overall supply amount (The amount of FIS that have already been created, minus any FIS that have been burned (removed from circulation). Total Supply = Onchain supply - burned tokens) "
        }
        remark="Total supply"
        icon={totalSupply}
      />
      <Item
        price={`${formatNumber(data?.circulating, { decimals: 2 })}`}
        spin={loading}
        unit="FIS"
        tips={`FIS current circulating supply amount (The amount of FIS that are circulating in the market and are tradeable by the public. It is comparable to looking at shares readily available in the market (not held & locked by insiders, governments)).`}
        remark="Circulating Supply"
        icon={circulating}
      />
      <Item
        price={`$${formatNumber(data?.price, { decimals: 2 })}`}
        tips={`current FIS price in USD`}
        spin={loading}
        remark="FIS Price"
        icon={fisPrice}
      />
      <Item
        price={`$${formatNumber(data?.marketCap, { decimals: 2 })}`}
        tips={`current FIS overall market cap (Market Cap = Current FIS Price x Circulating Supply. Refers to the total market value of a cryptocurrency’s circulating supply. It is similar to the stock market’s measurement of multiplying price per share by shares readily available in the market (not held & locked by insiders, governments))`}
        spin={loading}
        remark="Market Cap"
        icon={marketCap}
      />
    </div>
  );
}
